import React, { memo, useCallback, useMemo } from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { Close as CloseIcon } from '@picsio/ui/dist/icons';
import { IconButton } from '@picsio/ui';

import { formatCategoryChipParts } from '../helpers/formatCategoryLabel';
import s from './CategoryTag.module.scss';

const CategoryTag = ({
  item,
  readOnly,
  onClose,
}) => {
  const { primary, secondary } = useMemo(
    () => formatCategoryChipParts({
      name: item.name || item.title,
      fullName: item.fullName,
    }),
    [item.fullName, item.name, item.title],
  );

  const handleClose = useCallback((event) => {
    event.stopPropagation();
    onClose?.(event);
  }, [onClose]);

  if (!primary) return null;

  return (
    <div className={cn('tag', 'tagKeyword', s.tag)}>
      <span className={s.text}>
        <span className={s.primary}>{primary}</span>
        <If condition={secondary}>
          <span className={s.secondary}>{secondary}</span>
        </If>
      </span>
      <If condition={!readOnly && onClose}>
        <IconButton className={s.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </If>
    </div>
  );
};

CategoryTag.propTypes = {
  item: PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    name: PropTypes.string,
    fullName: PropTypes.string,
  }).isRequired,
  readOnly: PropTypes.bool,
  onClose: PropTypes.func,
};

CategoryTag.defaultProps = {
  readOnly: false,
  onClose: null,
};

export default memo(CategoryTag);
